import React, { useState, useEffect } from "react";
import TableIconModal from "../../../shares/TableIconModal";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Switch } from "@material-ui/core";
import useFetch from "../../../../context/useFetch";
import { toast } from "react-toastify";
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import ClearIcon from "@mui/icons-material/Clear";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

const CanRingOrdered = (props) => {
  const [openModal, setOpenModal] = useState(false);
  const [orderState, setOrderState] = useState(props.selectedRow?.is_active);

  const UpdateBangleApi = useFetch({
    method: "patch",
    url: `Bangle_Service/${props.selectedRow.id}`,
    data: { is_active: !orderState, can_edit: true },
    trigger: false,
    argFunc: (res) => {
      props.getRingsApi.reFetch();
      setOrderState(!orderState);
      // toast.success("تغییر وضعیت با موفقیت انجام شد ", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const change_state = () => {
    UpdateBangleApi.reFetch();
  };

  return (
    <>
      {orderState ? (
        <div className="accept-icon">
          <VerifiedUserIcon onClick={change_state} />
        </div>
      ) : (
        <div className="accept-icon">
          <ClearIcon color="secondary" onClick={change_state} />
        </div>
      )}
    </>
  );
};

export default CanRingOrdered;
